import React from 'react'
import R from 'ramda'
import { Row, Col } from 'react-bootstrap'
import EditableTable from '_/shared/components/editableTable'
import ensureNumber from '_/utils/ensureNumber'
import { List } from 'immutable'
import TransactionDetail from './transactionDetail'

/**
 * Lease detail page
 */
class LeaseDetail extends React.Component {
  static propTypes = {
    account: React.PropTypes.object.isRequired,
    metadata: React.PropTypes.object.isRequired,
    transaction: React.PropTypes.object.isRequired,
    link: React.PropTypes.func.isRequired,
    errors: React.PropTypes.object,
    onCertify: React.PropTypes.func.isRequired,
    editing: React.PropTypes.bool
  }

  constructor (props, context) {
    super(props, context)
    this.state = {
      onCertify: props.onCertify
    }
  }

  render() {
    const { account, metadata, link, transaction, errors, editing } = this.props
    const { onCertify } = this.state

    return (
      <div>
        <Row>
          <Col xs={6}>
            <EditableTable
              title="Lease: Particulars"
              link={link}
              errors={errors}
              editable={editing}
              metadata={metadata}
              account={account}
              onCertify={onCertify}
              data={transaction}
              fields={List([
                'catylistId',
                'leaseT',
                'listingDt',
                'leaseStDt',
                'leaseEndDt',
                'askRentLPx',
                'askRentHPx',
                'leasePx',
                'rentSfPx',
                'yrRentPx',
                'yrRentSfPx',
                'leaseTermT',
                'leaseLenYr',
                'termProv'
              ])}
            />

            <EditableTable
              title="Lease: Leasing fees"
              link={link}
              errors={errors}
              editable={editing}
              metadata={metadata}
              account={account}
              onCertify={onCertify}
              data={transaction}
              fields={List([
                'mgmtFeePct',
                'mgmtBase',
                'leaseCmPx',
                'leaseCmSfPx'
              ])}
            />

            <EditableTable
              title="Lease: Area"
              link={link}
              errors={errors}
              editable={editing}
              metadata={metadata}
              account={account}
              onCertify={onCertify}
              data={transaction}
              fields={List([
                'rentableSf',
                'rentableHSf',
                'rentableLSf',
                'floorLvl',
                'isFullFlr'
              ])}
            />

            <EditableTable
              title="Lease: TI's"
              link={link}
              errors={errors}
              editable={editing}
              metadata={metadata}
              account={account}
              onCertify={onCertify}
              data={transaction}
              fields={List([
                'tiPx',
                'tiSfPx',
                'tiRemarks'
              ])}
            />
          </Col>
          <Col xs={6}>
            <EditableTable
              title="Lease: Usage"
              link={link}
              errors={errors}
              editable={editing}
              metadata={metadata}
              account={account}
              onCertify={onCertify}
              data={transaction}
              fields={List([
                'useTM',
                'propUse',
                'propName',
                'leaseUse',
                'suiteNo',
                'lessee',
                'lesseeDba',
                'lessor',
                'lessorDba'
              ])}
            />

            <EditableTable
              title="Lease: Options"
              link={link}
              errors={errors}
              editable={editing}
              metadata={metadata}
              account={account}
              onCertify={onCertify}
              data={transaction}
              fields={List([
                'leaseOptT',
                'isSubLease',
                'isExclusive',
                'isGuaranty',
                'isAnchor',
                'freeRntExp',
                'isPurOpt',
                'purOptDt'
              ])}
            />

            <EditableTable
              title="Lease: Obligations"
              link={link}
              errors={errors}
              editable={editing}
              metadata={metadata}
              account={account}
              onCertify={onCertify}
              data={transaction}
              fields={List([
                'utilitiesT',
                'reTaxesT',
                'trashT',
                'insurT',
                'structRepT'
              ])}
            />

            <EditableTable
              title="Lease: Agent"
              link={link}
              errors={errors}
              editable={editing}
              metadata={metadata}
              account={account}
              onCertify={onCertify}
              data={transaction}
              fields={List([
                'leaseAgt',
                'leaseAgtEm',
                'leaseAgtPn'
              ])}
            />
          </Col>
        </Row>

        <EditableTable
          link={link}
          errors={errors}
          editable={editing}
          metadata={metadata}
          account={account}
          onCertify={onCertify}
          data={transaction}
          fields={List([
            'dataSrc',
            'linksM',
            'guarantyDesc',
            'remarks',
            'rediRemarks'
          ])}
        />
      </div>
    )
  }
}

export default TransactionDetail(LeaseDetail, {
  type: 'lease',
  hasCopy: true,
  calcMap: {
    _leaseCmSfPx (transaction, keyPath, value) {
      let leaseCmPxVal = ensureNumber(transaction.get('leaseCmPx'))
      let rentableSfVal = ensureNumber(transaction.get('rentableSf'))

      switch (R.last(keyPath)) {
        case 'leaseCmPx':
          leaseCmPxVal = ensureNumber(value)
          break
        case 'rentableSf':
          rentableSfVal = ensureNumber(value)
          break
      }

      if (leaseCmPxVal && rentableSfVal) {
        transaction.set('leaseCmSfPx', (leaseCmPxVal / rentableSfVal).toFixed(2))
      }
    },
    _leasePx (transaction, keyPath, value) {
      const moPx = value ? (ensureNumber(value) / 12).toFixed(2) : 0
      transaction.set('leasePx', moPx)
    },
    _leaseLenYr (transaction, keyPath, value) {
      if (transaction.get('leasePx') && value) {
        transaction.set('leaseLenYr',
          (ensureNumber(transaction.get('leasePx')) / ensureNumber(value)).toFixed(2)
        )
      }
    },
    _rentableSf (transaction, keyPath, value) {
      if (transaction.get('leasePx') && value) {
        transaction.set('rentableSf',
          (ensureNumber(transaction.get('leasePx')) / ensureNumber(value)).toFixed(0)
        )
      }
    },
    _rentSfPx (transaction, keyPath, value) {
      let leasePxVal = ensureNumber(transaction.get('leasePx'))
      let rentableSfVal = ensureNumber(transaction.get('rentableSf'))

      switch (R.last(keyPath)) {
        case 'leasePx':
          leasePxVal = ensureNumber(value)
          break
        case 'rentableSf':
          rentableSfVal = ensureNumber(value)
          break
      }

      if (leasePxVal && rentableSfVal) {
        transaction.set('rentSfPx', (leasePxVal / rentableSfVal).toFixed(2))
      }
    },
    _tiPx (transaction, keyPath, value) {
      if (transaction.get('rentableSf')) {
        transaction.set('tiPx',
          (ensureNumber(value) * ensureNumber(transaction.get('rentableSf'))).toFixed(2)
        )
      }
    },
    _tiSfPx (transaction, keyPath, value) {
      let tiPxVal = ensureNumber(transaction.get('tiPx'))
      let rentableSfVal = ensureNumber(transaction.get('rentableSf'))

      switch (R.last(keyPath)) {
        case 'tiPx':
          tiPxVal = ensureNumber(value)
          break
        case 'rentableSf':
          rentableSfVal = ensureNumber(value)
          break
      }

      if (tiPxVal && rentableSfVal) {
        transaction.set('tiSfPx', (tiPxVal / rentableSfVal).toFixed(2))
      }
    },
    _yrRentSfPx (transaction, keyPath, value) {
      let yrRentPxVal = ensureNumber(transaction.get('yrRentPx'))
      let rentableSfVal = ensureNumber(transaction.get('rentableSf'))

      switch (R.last(keyPath)) {
        case 'yrRentPx':
          yrRentPxVal = ensureNumber(value)
          break
        case 'rentableSf':
          rentableSfVal = ensureNumber(value)
          break
      }

      if (yrRentPxVal && rentableSfVal) {
        transaction.set('yrRentSfPx', (yrRentPxVal / rentableSfVal).toFixed(2))
      }
    },
    _yrRentPx (transaction, keyPath, value) {
      const yrPx = value ? (ensureNumber(value) * 12).toFixed(2) : 0
      transaction.set('yrRentPx', yrPx)
    },
    leasePx (transaction, keyPath, value) {
      this._rentSfPx(transaction, keyPath, value)
      this._yrRentPx(transaction, keyPath, value)
    },
    leaseCmPx (transaction, keyPath, value) {
      this._leaseCmSfPx(transaction, keyPath, value)
    },
    rentableSf (transaction, keyPath, value) {
      this._yrRentSfPx(transaction, keyPath, value)
      this._leaseCmSfPx(transaction, keyPath, value)
      this._rentSfPx(transaction, keyPath, value)
    },
    rentSfPx (transaction, keyPath, value) {
      this._rentableSf(transaction, keyPath, value)
    },
    tiPx (transaction, keyPath, value) {
      this._tiSfPx(transaction, keyPath, value)
    },
    tiSfPx (transaction, keyPath, value) {
      this._tiPx(transaction, keyPath, value)
    },
    yrRentPx (transaction, keyPath, value) {
      this._yrRentSfPx(transaction, keyPath, value)
      this._leaseLenYr(transaction, keyPath, value)
      this._leasePx(transaction, keyPath, value)
    }
  }
})



// WEBPACK FOOTER //
// ./modules/shared/pages/record/leaseDetail.js